import React from "react";

import cloneDeep from "lodash/cloneDeep";

import Table from "@cloudscape-design/components/table";
import Pagination from "@cloudscape-design/components/pagination";
import Header from "@cloudscape-design/components/header";
import Input from "@cloudscape-design/components/input";
import Button from "@cloudscape-design/components/button";
import Box from "@cloudscape-design/components/box";
import Grid from "@cloudscape-design/components/grid";
import Badge from "@cloudscape-design/components/badge";
import Preferences from "@cloudscape-design/components/collection-preferences";
import Alert from "@cloudscape-design/components/alert";
import Spinner from "@cloudscape-design/components/spinner";
import Select from "@cloudscape-design/components/select";

/* Recoil */
import { useRecoilValue, useSetRecoilState } from "recoil";
import { configStore } from "../stores/config";
import SpaceBetween from "@cloudscape-design/components/space-between";
import { playerModalStore } from "../stores/playerModal";
import { bonusesStore } from "../stores/bonuses";
import { bonusesAddModalStore } from "../stores/bonusesAddModal";
import { FortuneWheelStore } from "../stores/fortuneWheel";
/* ------- */

class FortuneWheel extends React.Component {
	constructor(props) {
		super(props);
	}

	handleKeyPress = (event) => {
		if (event.detail.key === "Enter") {
			setTimeout(() => {
				this.props.Interface.loadFortuneWheelList();
			}, 0);
		}
	};


	handleInputDebounceChange = (input, type) => {
		this.props.setFortuneWheel({
			...this.props.fortuneWheel,
			currentSearch: input.detail.value,
			pagination: {
				...this.props.fortuneWheel.pagination,
				current: 1,
			}
		});

		if (input.detail.value.length === 0) {
			setTimeout(() => this.props.Interface.loadFortuneWheelList(), 250)
		}
	};
	componentDidMount() {
		this.props.Interface.loadFortuneWheelList();
	}



	render() {
		return (
			<>
				{this.props.fortuneWheel.loaded && this.props.fortuneWheel.error.text.length ? (
					<Box
						margin={{ bottom: "m" }}
						children={
							<Alert
								type="error"
								header="Error loading data:"
								children={
									<>
										<Box variant="p" children={this.props.fortuneWheel.error.text} />
										<hr />
										<Box
											variant="p"
											children={
												<>
													request error code: {this.props.fortuneWheel.error.code} | request timestamp: {this.props.fortuneWheel.error.timestamp}
												</>
											}
										/>
									</>
								}
							/>
						}
					/>
				) : (
					<></>
				)}

				<Table
					stickyHeader="true"
					trackBy="id"
					loading={!this.props.fortuneWheel.loaded}
					sortingColumn={{ sortingField: this.props.fortuneWheel.sorting.sortingColumn.column }}
					sortingDescending={this.props.fortuneWheel.sorting.isDescending}
					onSortingChange={(sorting) => {
						this.props.setFortuneWheel({ ...this.props.fortuneWheel, sorting: {
								...this.props.fortuneWheel.sorting,
								sortingColumn: {
									order: !sorting.detail.isDescending ? "ASC" : "DESC",
									column: sorting.detail.sortingColumn.sortingField
								},
								isDescending: sorting.detail.isDescending,
							} });

						setTimeout(() => {
							this.props.Interface.loadFortuneWheelList();
						}, 250);
					}}
					columnDefinitions={[
						{
							id: "id",
							header: "ID",
							sortingField: "id",
							cell: (item) => (
								<Button
									iconName={"status-in-progress"}
									className={[this.props.styles["btnUID"], typeof document.body.classList[0] !== "undefined" ? this.props.styles["dark"] : "", this.props.styles["blue"]].join(" ")}
									variant="normal"
									onClick={() => {
										this.props.Interface.loadInfoFortuneWheel(item.id);
									}}
									children={item.id}
								/>
							),
						},
						{
							id: "uid",
							header: "UID",
							sortingField: "uid",
							cell: (item) => (
								<Button
									iconName={"status-in-progress"}
									className={[this.props.styles["btnUID"], typeof document.body.classList[0] !== "undefined" ? this.props.styles["dark"] : "", this.props.styles["blue"]].join(" ")}
									variant="normal"
									onClick={() => {
										this.props.Interface.loadInfo(item.uid);
									}}
									children={item.uid}
								/>
							),
						},
						{
							id: "amount",
							header: "Amount",
							cell: (item) => 	<Box variant="span" color={item.amount >= 0 ? (item.amount > 0 ? "text-status-success" : "text-body-secondary") : "text-status-error"}>
								{new Intl.NumberFormat("ru-RU", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(item.amount / 100)} RUB.
							</Box>,
						},
						{
							id: "minDeposit",
							header: "Min deposit",
							sortingField: "minDeposit",
							cell: (item) => item.minDeposit,
						},
						{ id: "timeout", header: "Timeout", sortingField: "timeout", cell: (item) => <>{item.timeout} sec.</> },
						{ id: "winnersCount", header: "Winners count", sortingField: "winnersCount", cell: (item) => item.winnersCount },
						{ id: "status", header: "Status", sortingField: "status", cell: (item) => item.status },
						{ id: "date", header: "Date", sortingField: "date", cell: (item) => <>{new Date(item.date).toLocaleDateString() + " " + new Date(item.date).toLocaleTimeString()}</> },
					]}
					items={this.props.fortuneWheel.data}
					pagination={
						<Pagination
							disabled={!this.props.fortuneWheel.loaded}
							currentPageIndex={this.props.fortuneWheel.pagination.current}
							pagesCount={this.props.fortuneWheel.pagination.total}
							onChange={(page) => {
								this.props.setFortuneWheel({ ...this.props.fortuneWheel, pagination: { ...this.props.fortuneWheel.pagination, current: page.detail.currentPageIndex } });
								setTimeout(() => {
									this.props.Interface.loadFortuneWheelList();
								}, 250)
							}}
						/>
					}
					preferences={
						<Preferences
							cancelLabel="Cancel"
							confirmLabel="Confirm"
							pageSizePreference={{ title: "Logs per page", options: this.props.config.fortuneWheel.preferences.perPage }}
							preferences={{ pageSize: this.props.config.fortuneWheel.perPage }}
							title="Preferences"
							onConfirm={(preferences) => {
								localStorage.setItem("fortuneWheel.perPage", preferences.detail.pageSize);
								this.props.setConfig({ ...this.props.config, fortuneWheel: { ...this.props.config.fortuneWheel, perPage: preferences.detail.pageSize } });

								setTimeout(() => {
									this.props.Interface.loadFortuneWheelList();
								}, 250);
							}}
						/>
					}
					filter={
						<Box
							margin={{ bottom: "m" }}
							children={
								<Grid
									gridDefinition={[{ colspan: 3 }, { colspan: 3 }, { colspan: 3 }, { colspan: 3 }]}
									children={
										<>
											<Input
												disableBrowserAutocorrect={true}
												placeholder="ID, Status, UID, Amount"
												inputMode="search"
												type="search"
												onKeyDown={this.handleKeyPress}
												value={this.props.fortuneWheel.currentSearch}
												onChange={(input) => {
													this.handleInputDebounceChange(input);
												}}
											/>
										</>
									}
								/>
							}
						/>
					}
					header={<Box
						margin={{ bottom: "m" }}
						children={
							<Header
								children="Fortune wheel"
								counter={
									<>
										({this.props.fortuneWheel.pagination.count})
									</>
								}
							/>
						}
					/>}
					empty="No fortuneWheel found with requested filter"
				/>
			</>
		);
	}
}

function withRecoil(Component) {
	return function WrappedComponent(props) {
		const fortuneWheel = useRecoilValue(FortuneWheelStore);
		const setFortuneWheel = useSetRecoilState(FortuneWheelStore);
		const config = useRecoilValue(configStore);
		const setConfig = useSetRecoilState(configStore);
		const playerModal = useRecoilValue(playerModalStore);
		const setPlayerModal = useSetRecoilState(playerModalStore);

		return <Component {...props} fortuneWheel={fortuneWheel} setFortuneWheel={setFortuneWheel} config={config} setConfig={setConfig} playerModal={playerModal} setPlayerModal={setPlayerModal} />;
	};
}

export default withRecoil(FortuneWheel);
